<template>
  <div>
    <FITAlert ref="successAlert" :alertSec="3.5">
      <div slot="content">
        <span class="fa fa-check-circle mr-2"></span><span class="h5">{{ $t('adm.cpd.alert.content') }}</span>
      </div>
    </FITAlert>
    <FITFormCard>
      <div slot="header">
        <b-row align-v="center" class="pb-2">
          <b-col cols="6">
            <span class="h5">{{ $t('adm.cpd.header') }}</span>
          </b-col>
          <b-col cols="6" class="text-right">
            <b-button variant="primary" size="md" @click="createTraining">
              <i class="fa fa-plus-circle mr-2"></i>{{ $t('adm.cpd.create.header') }}
            </b-button>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable ref="table" :filters="filters" :actions="actions" :columns="columns" searchAction="getTrainingList" vuexModule="CPD" type="training"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script>
import {
  FITSearchableTable,
  FITFormCard,
  FITModal,
  FITAlert
} from '@/components'

import {
  BulletinView
} from '@/Homepage/components'

import { mapGetters } from 'vuex'

import Vue from 'vue'

export default {
  name: 'TrainingList',
  components: {
    FITSearchableTable,
    FITFormCard,
    BulletinView,
    FITModal,
    FITAlert
  },
  props: {
    isSuccess: {
      type: Boolean,
      default: false
    },
    alertContent: {
      type: String,
      default: null
    },
    alertVariant: {
      type: String,
      default: null
    }
  },
  mounted() {
    console.debug('isSuccess', this.isSuccess)
    if (this.isSuccess) {
      this.$refs.successAlert.showAlert();
    }
  },
  methods: {

    createTraining() {
      this.$router.push({
        name: 'CPD Create'
      })
    },

    onRowClicked(row) {
      this.$router.push({
        name: 'CPD Create',
        params: {
          ID: row.ID
        }
      })
    },

    getTranslated(type, key) {
      if (!key) {
        return 'N/A';
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'CPD', type)
        .filter((item) => {
          return item.value === key
        });
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    }
  },

  computed: {
    ...mapGetters(['getTranslatedArray'])
  },
  data() {
    return {
      columns: [
        // {
        //   key: 'providerCode',
        //   label: this.$t('adm.cpd.list.providerCode'),
        //   sortable: true
        // }, 
        {
          key: 'providerName',
          label: this.$t('adm.cpd.list.providerName'),
          sortable: true,
          formatter: (row, key, item) => {
            return (row) ? row : 'N/A';
          }
        }, {
          key: 'trainingDate',
          label: this.$t('adm.cpd.list.trainingDate')
        }, {
          key: 'trainingName',
          label: this.$t('adm.cpd.list.trainingName')
        }, {
          key: 'trainingType',
          label: this.$t('adm.cpd.list.trainingType'),
          sortable: true,
          formatter: (row, key, item) => {
            return this.getTranslated('trainingType', row)
          }
        }, {
          key: 'updateTime',
          label: this.$t('adm.cpd.list.updateTime'),
          sortable: true,
        }
      ],

      actions: [{
        text: this.$t('adm.bulletin.edit'),
        key: 'edit',
        callback: (key, row, instance) => {
          let ID = parseInt(row.ID);

          this.$router.push({
            name: 'CPD Create',
            params: {
              ID: ID
            }
          })
        }
      }, ],

      filters: [{
          label: this.$t('adm.cpd.list.trainingType'),
          key: 'trainingType',
          type: 'select',
          default: null, // Default All
        },
        {
          label: this.$t('general.fromDate'),
          key: 'fromDate',
          type: 'datetime',
          default: ''
        },
        {
          label: this.$t('general.toDate'),
          key: 'toDate',
          type: 'datetime',
          default: ''
        }
      ],
      form: {},
    }
  }
}

</script>
<style>
.bulletin-subject {
  width: 450px;
  max-width: 450px;
}

.bulletin-time {
  width: 150px;
}

</style>



// WEBPACK FOOTER //
// src/Adm/CPD/components/TrainingList.vue